import { InputRule } from 'prosemirror-inputrules';
import { findWrapping, liftTarget, ReplaceAroundStep, canSplit } from 'prosemirror-transform';
import { NodeExtension } from '../../../core/index.js';
import { TextSelection, PluginKey, Plugin } from 'prosemirror-state';
import { NodeRange, Fragment, Slice } from 'prosemirror-model';
import { v4 } from 'uuid';
import 'prosemirror-commands';
import { gapCursorSituation, GapCursor } from '../../../citadel/kit/GapcursorSelection/index.js';
import { DecorationSet, Decoration } from 'prosemirror-view';

/**
 * 零宽度空格
 */ var ZERO_WIDTH_SPACE = "​";

// 获取浏览器和系统信息
function getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
    // Edge
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
    // MSIE
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
    // Chrome
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
    // Safari
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    // Firefox
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
    // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
    // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
    (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
    (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for(var id in clientStrings){
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch(os){
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};
// 类型是否可以插入富文本
var canInsertTypes = function(state) {
    var parentNode = state.selection.$from.parent;
    var textType = [
        "status",
        "code_block",
        "note_title",
        "collapse_title"
    ];
    return !textType.includes(parentNode.type.name);
};

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var listTypes = [
    "bullet_list",
    "ordered_list",
    "task_list"
];
var itemTypes = [
    "list_item",
    "task_item"
];
function doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
    var content = Fragment.empty;
    for(var i = wrappers.length - 1; i >= 0; i--){
        // 新增列表时如果遇到需要被序列为列表的内容有缩进的情况 需要把缩进属性添加到列表上并去除列表序列内容的缩进
        var attrs = null;
        if (!isSelectRange && wrappers[i].type === listType) {
            attrs = {
                indent: range.$from.parent.attrs.indent
            };
        }
        content = Fragment.from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
    }
    tr.step(new ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new Slice(content, 0, 0), wrappers.length, true));
    var found = 0;
    for(var i1 = 0; i1 < wrappers.length; i1++){
        if (wrappers[i1].type === listType) found = i1 + 1;
    }
    var splitDepth = wrappers.length - found;
    var splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    var parent = range.parent;
    var childNodes = [];
    for(var i2 = range.startIndex, e = range.endIndex, first = true; i2 < e; i2++, first = false){
        var childNode = parent.child(i2);
        childNodes.push(childNode);
        if (!first && canSplit(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i2).nodeSize;
    }
    // 去除列表序列内容的缩进
    tr.doc.nodesBetween(range.start, /**
     * range 的 start和end信息只能包含序列内容的范围 列表的结构如下 子节点length*2代表li标签的范围， +2代表外层ul/ol标签的范围
     * 三者相加之后才可以完整包含整个列表的范围
     * <ol>
     *    <li>序列内容</li>
     *    ...
     * </ol>
     */ range.end + childNodes.length * 2 + 2, function(node, pos) {
        if (childNodes.includes(node) && node.attrs.indent !== 0) {
            tr.setNodeMarkup(pos, null, _objectSpreadProps(_objectSpread({}, node.attrs), {
                indent: 0
            }));
        }
    });
    return tr;
}
function liftToOuterList(tr, itemType, range) {
    var transaction = tr;
    var end = range.end;
    var endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        transaction.step(new ReplaceAroundStep(end - 1, endOfList, end, endOfList, new Slice(Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new NodeRange(transaction.doc.resolve(range.$from.pos), transaction.doc.resolve(endOfList), range.depth);
    }
    return transaction.lift(range, liftTarget(range));
}
function liftOutOfList(tr, range) {
    var transaction = tr;
    var list = range.parent;
    // Merge the list items into a single big item
    for(var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        transaction.delete(pos - 1, pos + 1);
    }
    var $start = transaction.doc.resolve(range.start);
    var item = $start.nodeAfter;
    var atStart = range.startIndex === 0;
    var atEnd = range.endIndex === list.childCount;
    var parent = $start.node(-1);
    var indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? Fragment.empty : Fragment.from(list)))) {
        return false;
    }
    var start = $start.pos;
    var end = start + item.nodeSize;
    // 单独处理 data-diff-id 问题，后半段的 list 认为是新的 list，data-diff-id 重新生成
    // 详见 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/60669246
    var newList = list.copy(Fragment.empty);
    newList.attrs = _objectSpread({}, newList.attrs);
    newList.attrs.dataDiffId = "ct-diff-id-".concat(v4());
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    transaction.step(new ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new Slice((atStart ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))).append(atEnd ? Fragment.empty : Fragment.from(newList)), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    return transaction;
}
// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command function that wraps the selection in a list with
// the given type an attributes. If `dispatch` is null, only return a
// value to indicate whether this is possible, but don't actually
// perform the change.
function wrapInList(listType, attrs) {
    return function(tr, selRange) {
        var $to = selRange.$to;
        var $from = selRange.$from;
        // 根据 schema ，list_item 里面必须是 block 节点 如果 $from.parent 不是 block 先矫正 $from
        if (!$from.parent.isBlock) {
            var parentBlockNode = findParentNode(function(node) {
                return node.type.isBlock;
            })(selRange);
            $from = tr.doc.resolve(parentBlockNode.pos);
        }
        var transaction = tr;
        var range = $from.blockRange($to);
        // 光标（gaocursor）在块级元素前后时，需要设置 range 为该块元素，否则会无法设置列表
        if (_instanceof(selRange, GapCursor)) {
            if (selRange.gapCursorType === gapCursorSituation.afterNode && $from.nodeBefore) {
                range = new NodeRange(tr.doc.resolve($from.pos - $from.nodeBefore.nodeSize), $from, $from.depth);
            }
            if (selRange.gapCursorType === gapCursorSituation.beforeNode && $from.nodeAfter) {
                range = new NodeRange($from, tr.doc.resolve($from.pos + $from.nodeAfter.nodeSize), $from.depth);
            }
        }
        var doJoin = false;
        var outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            var $insert = transaction.doc.resolve(range.start - 2);
            outerRange = new NodeRange($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) {
                range = new NodeRange($from, transaction.doc.resolve($to.end(range.depth)), range.depth);
            }
            doJoin = true;
        }
        var wrap = findWrapping(outerRange, listType, attrs, range);
        if (!wrap) return false;
        var fromParent = $from.parent;
        var toParent = $to.parent;
        var isSelectRange = fromParent !== toParent || fromParent.type.name === "doc" && toParent.type.name === "doc";
        return doWrapInList(transaction, range, wrap, doJoin, listType, isSelectRange);
    };
}
// :: (NodeType) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
// Create a command to lift the list item around the selection up into
// a wrapping list.
function liftListItem(itemType) {
    return function(tr, selRange) {
        var transaction = tr;
        var $from = selRange.$from, $to = selRange.$to;
        var range = $from.blockRange($to, function(node) {
            return node.childCount && node.firstChild.type === itemType;
        });
        if (!range) return false;
        if ($from.node(range.depth - 1).type === itemType) {
            // Inside a parent list
            return liftToOuterList(transaction, itemType, range);
        }
        // Outer list node
        return liftOutOfList(transaction, range);
    };
}
function findListParentNode(selection) {
    // 找离当前光标最近的容器节点（不算 list_item 类型）
    var conatinerNode = findParentNode(function(n) {
        return n.isBlock && !n.isTextblock && !itemTypes.includes(n.type.name);
    })(selection);
    // 如果最近的容器节点是 list 类型，则返回该节点，否则返回 Null
    return conatinerNode && listTypes.includes(conatinerNode.node.type.name) ? conatinerNode : null;
}

// import { liftListItem } from "prosemirror-schema-list";
var handleListClick = function(listType) {
    return function(state, dispatch) {
        var tr = state.tr, selection = state.selection, schema = state.schema;
        var _schema_nodes = schema.nodes, list_item = _schema_nodes.list_item, task_item = _schema_nodes.task_item, bullet_list = _schema_nodes.bullet_list, ordered_list = _schema_nodes.ordered_list, task_list = _schema_nodes.task_list;
        var itemTypes = [
            list_item,
            task_item
        ];
        var listTypes = [
            bullet_list,
            ordered_list,
            task_list
        ];
        var transaction = tr;
        if (selection.forEachCell) {
            selection.ranges.forEach(function(originRange, i) {
                // 当前面的range增加列表后，range的位置发生改变，需要用 transaction.selection
                var _transaction_selection_ranges_i = transaction.selection.ranges[i], $from = _transaction_selection_ranges_i.$from, $to = _transaction_selection_ranges_i.$to;
                var range = $from.blockRange($to);
                if (!range) return false;
                var listNode = $from.parent.firstChild;
                // 当前不在任何列表中，新增列表
                if (!listNode || listNode.type !== listType) {
                    var newTr = wrapInList(listType)(transaction, range);
                    if (!newTr) return false;
                    transaction = newTr;
                } else {
                    var trueSelection = TextSelection.create(transaction.doc, $from.pos + 2, $to.pos - 2);
                    var itemType = listType === task_list ? task_item : list_item;
                    var trueRange = trueSelection.$from.blockRange(trueSelection.$to, function(node) {
                        return node.childCount && node.firstChild.type === itemType;
                    });
                    if (!trueRange) return false;
                    // 选中的列表类型与当前的列表类型一致，提升列表
                    var newTr1 = liftOutOfList(transaction, trueRange);
                    if (!newTr1) return false;
                    transaction = newTr1;
                }
            });
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        // 如果最近的容器节点是 list 类型，则是改变当前列表类型，否则是新增列表
        var listNodeInSelFrom = findListParentNode(selection);
        // 当前selection.from不在任何列表中，新增列表
        if (!listNodeInSelFrom) {
            transaction = wrapInList(listType)(transaction, selection);
            if (!transaction) return false;
            if (dispatch) dispatch(transaction);
            return true;
        }
        var listNodes = [];
        // 遍历选区，找到所有列表节点
        transaction.doc.nodesBetween(selection.from, selection.to, function(node, pos) {
            // 当前节点在选区内（list至少长度为4）
            if (listTypes.includes(node.type) && pos + 4 > listNodeInSelFrom.pos) {
                listNodes.push({
                    node: node,
                    pos: pos
                });
            }
        });
        listNodes.forEach(function(listNode) {
            var listNodePos = transaction.mapping.map(listNode.pos);
            // 提升列表时，只对当前选区内的列表节点进行操作
            var from = Math.max(listNodePos + 1, transaction.selection.from);
            var to = Math.min(listNode.node.nodeSize + listNodePos - 1, transaction.selection.to);
            // 选中的列表类型与当前的列表类型一致，提升列表
            var itemType = listType === task_list ? task_item : list_item;
            if (listNode.node.type === listType) {
                var newTr = liftListItem(itemType)(transaction, {
                    $from: transaction.doc.resolve(from),
                    $to: transaction.doc.resolve(to)
                });
                if (newTr) {
                    transaction = newTr;
                    return;
                }
            }
            // 转换列表类型
            from = listNodePos;
            to = listNode.node.nodeSize + from;
            // 转换当前列表类型为选中的类型
            transaction.doc.nodesBetween(from, to, function(node, pos) {
                if (listTypes.includes(node.type) && node.type !== listType) {
                    // 当前节点在选区内（list至少长度为4）
                    if (pos + 4 > from) {
                        transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
                    }
                } else if (itemTypes.includes(node.type) && node.type !== itemType) {
                    // 当前节点在选区内（listItem至少长度为2）
                    if (pos + 2 > from) {
                        transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
                    }
                }
            });
        });
        dispatch(transaction);
        return true;
    };
};

var isListActive = function(type) {
    return function() {
        return function(state) {
            var listNode = findListParentNode(state.selection);
            return listNode && listNode.node.type === type;
        };
    };
};

var ExtensionType;
(function(ExtensionType) {
    ExtensionType["Node"] = "node";
    ExtensionType["Mark"] = "mark";
    ExtensionType["NodeEmbed"] = "node-embed";
})(ExtensionType || (ExtensionType = {}));

/**
 * 通用配置
 */ var pluginKey = new PluginKey("image");

var isCommonDisabled = function() {
    return function(state) {
        return !canInsertTypes(state);
    };
};

/**
 * keys--不区分大小写
 */ // "META_KEY-0"-正文
// 任务列表
var regexpTaskList = /^\[]\s$/;

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.pm-body-wrapper ul,.ProseMirror ul{margin:8px 0;padding-left:24px}.pm-body-wrapper ul li,.ProseMirror ul li{min-height:24px;font-size:14px}.pm-body-wrapper ul>h1,.pm-body-wrapper ul>h2,.pm-body-wrapper ul>h3,.pm-body-wrapper ul>h4,.pm-body-wrapper ul>h5,.pm-body-wrapper ul>h6,.pm-body-wrapper ul>p,.ProseMirror ul>h1,.ProseMirror ul>h2,.ProseMirror ul>h3,.ProseMirror ul>h4,.ProseMirror ul>h5,.ProseMirror ul>h6,.ProseMirror ul>p{margin:0}.pm-body-wrapper ul .ct-image,.ProseMirror ul .ct-image{vertical-align:top}.pm-body-wrapper ul hr,.ProseMirror ul hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px!important}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px!important}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px!important}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px!important}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px!important}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px!important}ul .ct-item-level-1{margin-left:7px}ul .ct-item-level-2{margin-left:6px}ul .ct-item-level-3{margin-left:3px}ul .ct-item-level-4{margin-left:2px}ul .ct-item-level-6{margin-left:-1px}.ct-task-list{list-style-type:none!important}.ct-task-list li{margin-left:0}.ct-task-list .ct-task-li{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg transform%3D%22translate(-57.000000%2C -393.000000)%22 fill%3D%22%236E6B6B%22%3E            %3Cg transform%3D%22translate(56.000000%2C 389.000000)%22%3E                %3Cpath d%3D%22M1%2C4 L17%2C4 L17%2C20 L1%2C20 L1%2C4 Z M2%2C5 L2%2C19 L16%2C19 L16%2C5 L2%2C5 Z%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-task-list .ct-task-li-checked{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li-checked:before{content:"";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url("data:image/svg+xml,%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%2203%E3%80%81%E7%BC%96%E8%BE%91%E9%A1%B5-%E4%BB%BB%E5%8A%A1%E5%88%97%E8%A1%A8%EF%BC%881024%EF%BC%89%22 transform%3D%22translate(-57.000000%2C -497.000000)%22 fill%3D%22%23AAAAAA%22%3E            %3Cg id%3D%22Group-13-Copy%22 transform%3D%22translate(56.000000%2C 493.000000)%22%3E                %3Cg id%3D%22Group-3%22 transform%3D%22translate(1.000000%2C 4.000000)%22%3E                    %3Cpath d%3D%22M12%2C1.11022302e-16 L12%2C1 L1%2C1 L1%2C15 L15%2C15 L15%2C7 L16%2C7 L16%2C16 L0%2C16 L0%2C0 L12%2C0 Z M6.90823822%2C9.72780075 L14.2928932%2C2.34314575 C14.6834175%2C1.95262146 15.3165825%2C1.95262146 15.7071068%2C2.34314575 C16.0976311%2C2.73367004 16.0976311%2C3.36683502 15.7071068%2C3.75735931 L7.63603897%2C11.8284271 C7.43551353%2C12.0289526 7.17101366%2C12.1265127 6.90823822%2C12.1211075 C6.64546278%2C12.1265127 6.38096291%2C12.0289526 6.18043747%2C11.8284271 L2.93779678%2C8.58578644 C2.54727249%2C8.19526215 2.54727249%2C7.56209717 2.93779678%2C7.17157288 C3.32832107%2C6.78104858 3.96148605%2C6.78104858 4.35201034%2C7.17157288 L6.90823822%2C9.72780075 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-task-li-checked:after,.ct-task-li-checked:before,.ct-task-li:before{cursor:pointer}.ct-task-list .ct-item-level-1:before{top:15px}.ct-task-list .ct-item-level-2:before{top:12px}.ct-task-list .ct-item-level-3:before{top:8px}.ct-task-list .ct-item-level-4:before{top:5px}.ct-task-list .ct-item-level-6:before{top:1px}.ct-task-list .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked div,.ct-task-list .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked p,.ct-task-list .ct-task-li-checked span,.ct-task-list .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}';
styleInject(css_248z);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var pluginKey$1 = new PluginKey("taskList");
var TaskListExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits(TaskListExtension, NodeExtension);
    var _super = _createSuper(TaskListExtension);
    function TaskListExtension() {
        _classCallCheck(this, TaskListExtension);
        return _super.apply(this, arguments);
    }
    var _proto = TaskListExtension.prototype;
    _proto.plugin = function plugin() {
        var showDesc = false; // 判断Decoration是否显示的一个标志位
        return new Plugin({
            key: pluginKey$1,
            props: {
                decorations: function decorations(state) {
                    // 不是Safari无需处理，没有任务列表消失的问题 https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/65305935
                    // 分析文档：https://km.sankuai.com/collabpage/1296547289
                    if (getSystemInfo().browser !== "Safari" || !showDesc) {
                        return DecorationSet.empty;
                    }
                    var selection = state.selection;
                    var $from = selection.$from;
                    if ($from.depth < 3) {
                        return DecorationSet.empty;
                    } // 任务列表的depth至少为3
                    var grandParentNode = $from.node($from.depth - 2); // 向上两级，深度为2 ul>li  --- task_list>task_item
                    // 不是在任务列表不处理
                    if (grandParentNode && grandParentNode.type.name === "task_list") {
                        var widget = document.createElement("span");
                        widget.innerText = ZERO_WIDTH_SPACE;
                        var deco = Decoration.widget(selection.to, widget);
                        return DecorationSet.create(state.doc, [
                            deco
                        ]);
                    }
                    return DecorationSet.empty;
                },
                handleDOMEvents: {
                    compositionstart: function() {
                        showDesc = true;
                        return false;
                    },
                    compositionend: function() {
                        showDesc = false;
                        return false;
                    }
                }
            }
        });
    };
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            handleListClick: function() {
                return handleListClick(type);
            },
            isTaskListActive: isListActive(type),
            isTaskListDisabled: isCommonDisabled
        };
    };
    _proto.inputRules = function inputRules(param) {
        var type = param.type, getView = param.getView;
        return [
            new InputRule(new RegExp(regexpTaskList), function(state, match, start, end) {
                var range = state.tr.doc.resolve(start).blockRange();
                var wrapping = range && findWrapping(range, type);
                if (!wrapping) return null;
                var view = getView();
                var transaction = view.state.tr.deleteRange(start, end);
                transaction = wrapInList(type)(transaction, transaction.selection);
                if (transaction) {
                    view.dispatch(transaction);
                    return view.state.tr; // 返回空tr表示已经处理inputRule
                }
                return null;
            })
        ];
    };
    _createClass(TaskListExtension, [
        {
            key: "name",
            get: function get() {
                return "task_list";
            }
        }
    ]);
    return TaskListExtension;
}(NodeExtension);

export { TaskListExtension, pluginKey$1 as pluginKey };
//# sourceMappingURL=index.js.map
